module.exports = __webpack_public_path__ + "static/media/m.bc7c2ee7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/m.jpg
// module id = 94
// module chunks = 0